import { useTheme } from "@mui/material";
import React from "react";
import {
  ComposableMap,
  Geographies,
  Geography
} from "react-simple-maps";
import { tokens } from "../../theme";
import india from './topojsons/india.json';

const MapChart = ({ setTooltipContent, setStateName, setShowDistrict }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <>
      <ComposableMap data-tip="" projection="geoMercator" width={140} height={140} projectionConfig={{ scale: 250, center: [81, 23] }}>
        <Geographies geography={india}>
          {({ geographies }) =>
            geographies.map(geo => (
              <Geography
                key={geo.rsmKey}
                geography={geo}
                onMouseEnter={() => {
                  const { ST_NM } = geo.properties;
                  setTooltipContent(`${ST_NM}`);
                }}
                onMouseLeave={() => {
                  setTooltipContent("");
                }}
                onClick={() => {
                  const { ST_NM } = geo.properties;
                  setStateName(`${ST_NM}`);

                  setShowDistrict(true);
                }}
                style={{
                  default: {
                    fill: colors.greenAccent[300],
                    outline: "none"
                  },
                  hover: {
                    fill: colors.grey[400],
                    outline: "none"
                  },
                  pressed: {
                    fill: "#2E8B57",
                    outline: "none"
                  }
                }}
              />
            ))
          }
        </Geographies>
      </ComposableMap>
    </>
  );
};

export default MapChart;
